var StatusTypes;
(function (StatusTypes) {
    StatusTypes["INFO"] = "info";
    StatusTypes["WARNING"] = "warning";
    StatusTypes["ERROR"] = "error";
    StatusTypes["SUCCESS"] = "success";
    StatusTypes["DEFAULT"] = "default";
    StatusTypes["NONE"] = "none";
})(StatusTypes || (StatusTypes = {}));

export { StatusTypes as S };

//# sourceMappingURL=statusTypes-44ddf7d8.js.map